/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { BeatLoader } from "react-spinners"; // Import the loader component
import "../assets/css/bootstrap/bootstrap.css";
import "../assets/css/bootstrap/bootstrap-grid.css";
import "../assets/css/bootstrap/bootstrap-reboot.css";
import "../assets/css/backend-plugin.min.css";
import "../assets/vendor/remixicon/fonts/remixicon.css";
import "../assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "../assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import { useTranslate } from "../hooks/LanguageProvider";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { Modal, Button, Form } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface LoginFormProps {
  //onLogin: (token: string) => void;
}

const SignUp: React.FC<LoginFormProps> = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state
  const [alertMessage, setAlertMessage] = useState("");
  const { translate } = useTranslate();
  const { lang, setLang } = useTranslate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedProblem, setSelectedProblem] = useState("forgotPassword");
  const [otherMessage, setOtherMessage] = useState("");

  const { login } = useAuth();

  const strLang = {
    en: "English",
    fr: "French",
    ar: "Arabic",
    es: "Espagnol",
  };

  const handleLanguageChange = (newLang: any) => {
    setLang(newLang);
  };

  const loginButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "Enter" && loginButtonRef.current) {
        loginButtonRef.current.click();
      }
    };

    document.body.addEventListener("keypress", handleKeyPress);

    return () => {
      document.body.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const handleLogin = async () => {
    const securedPassword = password;

    try {
      setLoading(true);
      // Backend API call to set the JWT cookie
      await axios.post(
        `${backendUrl}/api/login`,
        {
          username,
          password: securedPassword,
        },
        {
          withCredentials: true, // ⬅️ sends the cookie
        },
      );

      await login(); // ⬅️ calls /api/me from the AuthContext
      sessionStorage.setItem("forceReload", "1");
      // navigate("/"); // redirection post-login
      window.location.href = "/";
    } catch (error: any) {
      if (error.response?.status === 401) {
        setAlertMessage(translate("incorrectCredentials"));
      } else if (error.response?.status === 500) {
        setAlertMessage(translate("connectionProblem"));
      } else if (error.response?.status === 402) {
        setAlertMessage(translate("userNotFound"));
      } else {
        setAlertMessage("Connection error.");
      }
      console.error("Login error", error);
    } finally {
      setLoading(false);
    }
  };

  // Refs for form fields
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const userNameRef = useRef(null);
  const companyRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  const handleSubmit = async () => {
    try {
      const firstName =
        (firstNameRef.current as HTMLInputElement | null)?.value ?? "";
      const lastName =
        (lastNameRef.current as HTMLInputElement | null)?.value ?? "";
      const userName =
        (userNameRef.current as HTMLInputElement | null)?.value ?? "";
      const company =
        (companyRef.current as HTMLInputElement | null)?.value ?? "";
      const email = (emailRef.current as HTMLInputElement | null)?.value ?? "";
      const phone = (phoneRef.current as HTMLInputElement | null)?.value ?? "";

      // Additional check of required values
      if (
        !firstName ||
        !lastName ||
        !userName ||
        !company ||
        !email ||
        !phone ||
        !selectedProblem
      ) {
        console.error("Missing form values");
        return;
      }

      await axios.post(`${backendUrl}/api/submit-form`, {
        firstName,
        lastName,
        userName,
        company,
        email,
        phone,
        problem: selectedProblem,
        otherMessage,
      });

      // Handle success response if needed

      handleClose(); // Close the modal after successful submission
    } catch (error) {
      // Handle error response if needed
      console.error("Form submission error", error);
    }
  };

  return (
    <div className="wrapper">
      <section className="login-content">
        <div className="row">
          <div className="col-sm-7" style={{ margin: 0, padding: 0 }}>
            <div className="aida-bg-auth"></div>
          </div>
          <div className="col-sm-5" style={{ padding: "25px 30px" }}>
            <div className="card-body p-0">
              <div className="row d-flex flex-column align-items-center justify-content-center">
                <div className="col-lg-12 text-center">
                  <img
                    src="asset/images/logo.png"
                    alt="AIADI"
                    className="img-fluid small-logo"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      marginTop: "40px",
                    }}
                  />
                </div>
              </div>

              <div
                className=""
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  height: "75vh",
                  paddingTop: "15vh", //
                  transform: "translateY(-15%)",
                }}
              >
                <div className="container">
                  <div className=" mx-auto">
                    <div className="p-3">
                      <h2 className="mb-2">
                        {translate("Member space")} , {translate("Login")}!
                      </h2>
                      <p>{translate("Please enter your details to login")}!</p>

                      <form className="smart-form client-form client-form-size">
                        <div id="resText"></div>
                        <div className="row">
                          <div className="col-lg-12">
                            <label>{translate("Username")}</label>
                            <div className="floating-label form-group">
                              <input
                                className="floating-input form-control"
                                type="text"
                                placeholder="Enter your username"
                                name="username"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="mb-1">
                              <div className="d-flex justify-content-between align-items-center">
                                <label
                                  className="form-label mb-0"
                                  htmlFor="password"
                                >
                                  {translate("Password")}
                                </label>
                                <Link to="/forgot-password">
                                  <small>
                                    {translate("Forgot your password")}?
                                  </small>
                                </Link>
                              </div>

                              <div className="input-group input-group-merge form-password-toggle">
                                <input
                                  className="form-control form-control-merge"
                                  id="password"
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  placeholder="············"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                />

                                <span
                                  className="input-group-text cursor-pointer"
                                  onClick={() => setShowPassword(!showPassword)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {showPassword ? <IoEyeOff /> : <IoEye />}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="text-center mb-1 mt-4">
                              <button
                                type="button"
                                className="btn btn-primary col-lg-12 mx-auto d-block"
                                onClick={handleLogin}
                                ref={loginButtonRef}
                              >
                                {translate("Login")}
                              </button>
                            </div>
                            {loading && (
                              <div className="text-center">
                                <BeatLoader
                                  color={"#123abc"}
                                  loading={loading}
                                  size={12}
                                />
                              </div>
                            )}
                          </div>
                        </div>

                        <p className="text-center mt-2">
                          <span>{translate("New on our platform?")}</span>
                          <Link to="/sign-up">
                            <span>&nbsp;{translate("Create an account")}</span>
                          </Link>
                        </p>

                        <p className="text-center mt-2"></p>

                        {alertMessage && (
                          <div
                            style={{
                              padding: "15px",
                              marginBottom: "20px",
                              border: "1px solid transparent",
                              borderRadius: "4px",
                              color: "#721c24",
                              backgroundColor: "#f8d7da",
                              borderColor: "#f5c6cb",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                            role="alert"
                          >
                            {alertMessage}
                          </div>
                        )}
                        <p
                          className="description-text"
                          style={{ marginBottom: 0, textAlign: "center" }}
                        >
                          {translate("By clicking")}
                          <span className="text-grey1 fw6">
                            {" "}
                            {translate("Login")}{" "}
                          </span>
                          , {translate("you are agreeing to our")}
                          <a
                            className="text-grey1 text-underline-none fw6"
                            href="https://aida-dz.xyz"
                            target="_blank"
                          >
                            {" "}
                            {translate("Terms of use")}
                          </a>
                          &amp;{" "}
                          <a
                            className="text-grey1 text-underline-none fw6"
                            href="https://aida-dz.xyz"
                            target="_blank"
                          >
                            {translate("Privacy Policy")}
                          </a>
                          .
                        </p>
                      </form>
                    </div>
                    <Modal show={show} onHide={handleClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>
                          {translate("Forgot Password")}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form>
                          <Form.Group controlId="firstName">
                            <Form.Label>{translate("first name")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={translate("first name")}
                              ref={firstNameRef}
                            />
                          </Form.Group>
                          <Form.Group controlId="lastName">
                            <Form.Label>{translate("Family Name")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={translate("Family Name")}
                              ref={lastNameRef}
                            />
                          </Form.Group>
                          <Form.Group controlId="userName">
                            <Form.Label>{translate("Username")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={translate("Username")}
                              ref={userNameRef}
                            />
                          </Form.Group>
                          <Form.Group controlId="Company">
                            <Form.Label>{translate("User")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={translate("User")}
                              ref={companyRef}
                            />
                          </Form.Group>
                          <Form.Group controlId="email">
                            <Form.Label>{translate("Email")}</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder={translate("Email")}
                              ref={emailRef}
                            />
                          </Form.Group>
                          <Form.Group controlId="phone">
                            <Form.Label>{translate("Phone")}</Form.Label>
                            <Form.Control
                              type="phone"
                              placeholder={translate("Phone")}
                              ref={phoneRef}
                            />
                          </Form.Group>
                          <Form.Group>
                            <br />
                            <Form.Label>
                              {translate("What seems to be the problem?")}
                            </Form.Label>
                            <Form.Check
                              type="radio"
                              id="forgotPassword"
                              name="problem"
                              label={translate("Forgot Password")}
                              checked={
                                selectedProblem === translate("Forgot Password")
                              }
                              onChange={() =>
                                setSelectedProblem(translate("Forgot Password"))
                              }
                            />
                            <Form.Check
                              type="radio"
                              id="connectionProblem"
                              name="problem"
                              label={translate("Connection Problem")}
                              checked={
                                selectedProblem ===
                                translate("Connection Problem")
                              }
                              onChange={() =>
                                setSelectedProblem(
                                  translate("Connection Problem"),
                                )
                              }
                            />
                            <Form.Check
                              type="radio"
                              id="other"
                              name="problem"
                              label={translate("Other")}
                              checked={selectedProblem === "other"}
                              onChange={() => setSelectedProblem("other")}
                            />
                            {selectedProblem === "other" && (
                              <Form.Group controlId="otherMessage">
                                <Form.Label>
                                  {translate("Please describe the issue:")}
                                </Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  value={otherMessage}
                                  onChange={(e) =>
                                    setOtherMessage(e.target.value)
                                  }
                                />
                              </Form.Group>
                            )}
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                          {translate("Close")}
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                          {translate("Submit")}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignUp;
